import { NavbarOption } from 'modules/nav/types';
import { NavLink } from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import styled, { css } from 'styled-components';
import { body2, colors, spacing } from 'ui/theme';

export const styles = css`
  ${body2}
  border-radius: ${spacing.quarter};
  color: ${colors.textSecondary};
  display: block;
  padding: ${spacing.half};
  text-align: left;
  width: 100%;
  &:hover {
    background: ${colors.backgroundPrimaryHover};
    color: ${colors.textPrimary};
  }
  &:active,
  &[aria-current='true'] {
    background: ${colors.backgroundInteractive};
    color: ${colors.textLink};
  }
`;

const RouterLink = styled(NavLink)`
  ${styles}
`;

const Anchor = styled.a`
  ${styles}
`;

const Button = styled.button`
  background: ${colors.backgroundPrimary};
  border: none;
  ${styles}
`;

type Props = NavbarOption & {
  isCurrentPage?: boolean;
  onClick?: () => void;
};

export const MenuOption = ({ href, onClick, isExternal, title, isCurrentPage }: Props) => {
  const { path } = useRouteMatch();
  const ariaCurrent = isCurrentPage || path === href ? 'true' : 'false';

  if (onClick)
    return (
      <Button onClick={onClick} aria-current={ariaCurrent} data-type="button">
        {title}
      </Button>
    );

  return !isExternal ? (
    <RouterLink to={href as string} aria-current={ariaCurrent} data-type="navlink">
      {title}
    </RouterLink>
  ) : (
    <Anchor aria-current={ariaCurrent} href={href} data-type="anchor">
      {title}
    </Anchor>
  );
};
